import { Button, Descriptions, Drawer, Image, Tooltip } from "antd";
import React from "react";
import { CloseOutlined } from "@ant-design/icons";
// import Img from "./../../../../assets/empty.png";

const MerchantFoodpandaProductInfo = ({ open, close, selectedData }) => {
  // console.log("selectedData: ", selectedData);

  return (
    <Drawer onClose={close} open={open} placement="right" closable={false}>
      <div
        style={{
          height: "100%",
          overflow: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            marginBottom: 10,
          }}
        >
          <div style={{ flexGrow: 1 }}></div>
          <div>
            <Tooltip title="Close">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  close();
                }}
                icon={<CloseOutlined />}
              />
            </Tooltip>
          </div>
        </div>

        <Descriptions
          // title="Product Info"
          column={1}
        >
          <Descriptions.Item
            label="Product"
            contentStyle={{
              fontWeight: "bold",
            }}
          >
            {selectedData.product}
          </Descriptions.Item>

          <Descriptions.Item
            label="Product Link to"
            contentStyle={{
              fontWeight: "bold",
            }}
          >
            {selectedData.productlinkto.product}
          </Descriptions.Item>

          {selectedData.description !== null && (
            <Descriptions.Item
              label="Description"
              contentStyle={{
                fontWeight: "bold",
              }}
            >
              {selectedData.description}
            </Descriptions.Item>
          )}

          <Descriptions.Item
            label="SRP"
            contentStyle={{
              fontWeight: "bold",
            }}
          >
            &#8369;{selectedData.srp}
          </Descriptions.Item>

          <Descriptions.Item
            label="Status"
            contentStyle={{
              fontWeight: "bold",
              color: parseInt(selectedData.status) === 1 ? "green" : "red",
            }}
          >
            {parseInt(selectedData.status) === 1 ? "Available" : "Unavailable"}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </Drawer>
  );
};

export default MerchantFoodpandaProductInfo;
